<template>
  <div class="flex flex-col">
    <NoteBox header="Hiring Tip" :body="randomHiringTipMessage" class="xs:mt-0 md:mt-24 mb-80 md:mb-0" />
  </div>
</template>

<script lang="ts">
import NoteBox from '@/components/note_box/NoteBox.vue';

export default {
  name: 'HiringTip',
  components: { NoteBox },
  computed: {
    randomHiringTipMessage(): string {
      const tipMessages = [
        "Don't worry about typos; a sitter's love for your child isn't measured by grammar. Focus on their experience and passion for child care instead.",
        'For the most up-to-date results, run a background check right before making a hiring decision. It ensures you have the latest information.',
        'Act swiftly when responding; great sitters are in high demand, so snatch them up before someone else does.',
        "Once you've found your perfect sitter or have enough applicants, close your job to avoid unnecessary applications.",
        'Always ask for references; reliable sitters will gladly provide them, offering peace of mind for you and your child.',
        'Discuss pay openly; sitters appreciate negotiation. Use their suggested range as a starting point for this important conversation.',
      ];
      return tipMessages[Math.floor(Math.random() * tipMessages.length)];
    },
  },
};
</script>
